import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/guests.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DiscoverSicilySections/MultiCarouselSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SideNavigator"] */ "/vercel/path0/src/components/DiscoverSicilySections/SideNavigator/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DiscoverSicilySections/SingleCarouselSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SurroundingSection"] */ "/vercel/path0/src/components/DiscoverSicilySections/SurroundingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExperienceCarouselItem"] */ "/vercel/path0/src/components/ExperienceCarousel/Item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/GuideMap/Root.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/InPageNavigationTab/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/LoadOnInteract/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/MultiCarousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/PlanYourTripButton/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/StickyHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VillageCarouselGallery"] */ "/vercel/path0/src/components/VillaCarousel/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VillageCarouselOptions"] */ "/vercel/path0/src/components/VillaCarousel/Options.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/VillageCard/Options.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/VillageCard/Root.tsx");
